module.exports = __webpack_public_path__ + "img/reward_bg.47ceaadf.png";